import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyA08vrLHsO_0ltjFfxbkvslT6xbMzPbrtw",
    authDomain: "e-commerce-project-db-44c29.firebaseapp.com",
    projectId: "e-commerce-project-db-44c29",
    storageBucket: "e-commerce-project-db-44c29.appspot.com",
    messagingSenderId: "579356149790",
    appId: "1:579356149790:web:6eb575fde262318809860f",
    measurementId: "G-Y9EL2384GV"
  };

  export const createUserProfileDocument = async (userAuth, additionalData) => {
    if(!userAuth)return

    const userRef = firestore.doc(`users/${userAuth.uid}`);

    const snapShot = await userRef.get();

    if(!snapShot.exists) {
      const { displayName, email} = userAuth;
      const createdAt = new Date();

      try{
        await userRef.set(
          {
            displayName,
            email,
            createdAt,
            ...additionalData
          }
        )
      } catch(error){
        console.log('error creating user', error.message);
      }
    }
    return userRef;
  };

  firebase.initializeApp(config);

  export const auth = firebase.auth();
  export const firestore = firebase.firestore();

  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({prompt: 'select_account'});
  export const signInWithGoogle = () => auth.signInWithPopup(provider);

  export default firebase;